/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MemberIncomeInputDto { 
    userId: number;
    isEmployment?: boolean | null;
    companyName?: string | null;
    companyAddress?: string | null;
    monthlyIncome?: number | null;
    contractTypeId?: number | null;
    isBusiness?: boolean | null;
    businessAddress?: string | null;
    businessRegistrationNumber?: string | null;
    licenseNumber?: string | null;
    tinNumber?: string | null;
    businessTurnOver?: number | null;
    payRollNumber?: string | null;
    occupationType?: string | null;
}

